import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'

Vue.config.productionTip = false

import VueWow from 'vue-wow'
 
// mount with global
Vue.use(VueWow)

import VueSocketIO from 'vue-socket.io'

Vue.use(new VueSocketIO({
    debug: true,
    connection: 'https://explorer.mchain.network',
}))

new Vue({
 	render: h => h(App),
}).$mount('#app')
